import type { AxiosResponse } from 'axios'
import { AbsNetAdapter } from '@/netadapters/AbsNetAdapter'
import { InvalidAccountAuthorityException } from '@/core/Exceptions'
import { isFrameReloginDisabled } from '@/DebugConfig'

export abstract class AuthAdapter<T> extends AbsNetAdapter<T> {
  constructor() {
    super()
  }

  protected abstract _isInvalidAuth(res: AxiosResponse<T>): boolean
  protected async _interceptFulfillResponse(res: AxiosResponse) {
    const response = await super._interceptFulfillResponse(res)

    if (this._isInvalidAuth(response) && !isFrameReloginDisabled()) {
      Promise.reject(new InvalidAccountAuthorityException())
    }

    return response
  }
}
